import { jsx as _jsx } from "react/jsx-runtime";
import Fade from '@material-ui/core/Fade';
import cn from 'classnames';
import withStyles from '../../core/withStyles';
import { testAttr } from '../../helpers';
import styles from './Overlay.styles';
export const Overlay = ({ className, onClick, children, classes, testId, }) => {
    const clickProps = {
        onClick,
        tabIndex: -1,
        role: 'button',
        style: { cursor: 'pointer' },
    };
    return (_jsx(Fade, Object.assign({ in: true }, { children: _jsx("div", Object.assign({ className: cn(classes.overlay, className) }, (onClick ? clickProps : {}), testAttr(testId), { children: children })) })));
};
export default withStyles(styles)(Overlay);
//# sourceMappingURL=Overlay.js.map